import React from "react";
import Input from "../../../../../components/FormComponents/Input";
import SelectSubfields from "../../../EditFieldAttribute/SelectSubfields";
import AppUserFilter from "../../../EditFieldAttribute/AppUserFilter";
import { getLabelForKey } from "../../../../../utils/Config/DefaultConfig/formFieldConfig";

const EditAppuser = (props) => {
  const { editFieldData, setEditFieldData } = props;
  const handleChangeInput = (name, value) => {
    setEditFieldData({ ...editFieldData, [name]: value });
  };
  const handleChangeValidationInput = (name, value) => {
    setEditFieldData({ ...editFieldData, validate: { ...editFieldData.validate, [name]: value } });
  };
  return (
    <>
      <Input
        label={getLabelForKey("label")}
        value={editFieldData.label}
        name="label"
        onChange={({ target }) => handleChangeInput(target.name, target.value)}
      />
      <Input
        label={getLabelForKey("form_display_label")}
        value={editFieldData.form_display_label}
        name="form_display_label"
        onChange={({ target }) => handleChangeInput(target.name, target.value)}
      />
      <div className="d_flex">
        <Input
          type="checkbox"
          label={getLabelForKey("required")}
          checked={editFieldData.validate.required}
          name="required"
          onChange={({ target }) => handleChangeValidationInput(target.name, target.checked)}
          containerClassName="w_50"
        />
        <Input
          type="checkbox"
          label={getLabelForKey("disable")}
          checked={editFieldData.disable}
          name="disable"
          onChange={({ target }) => handleChangeInput(target.name, target.checked)}
          containerClassName="w_50"
        />
      </div>
      <div className="d_flex">
        <Input
          type="checkbox"
          label={getLabelForKey("prefill_current_user")}
          checked={editFieldData.prefill_current_user}
          name="prefill_current_user"
          onChange={({ target }) => handleChangeInput(target.name, target.checked)}
          containerClassName="w_50"
        />
        <Input
          type="checkbox"
          label={getLabelForKey("show_default_option")}
          checked={editFieldData.show_default_option}
          name="show_default_option"
          onChange={({ target }) => handleChangeInput(target.name, target.checked)}
          containerClassName="w_50"
        />
      </div>
      <div className="d_flex">
        <Input
          type="checkbox"
          label={getLabelForKey("show_app_user_team_only")}
          checked={editFieldData.show_app_user_team_only}
          name="show_app_user_team_only"
          onChange={({ target }) => handleChangeInput(target.name, target.checked)}
          containerClassName="w_50"
        />
        <Input
          type="checkbox"
          label={getLabelForKey("mandatory")}
          checked={editFieldData.validate.mandatory}
          name="mandatory"
          onChange={({ target }) => handleChangeValidationInput(target.name, target.checked)}
          containerClassName="w_50"
        />
      </div>
      <div className="d_flex">
        <Input
          type="checkbox"
          label={getLabelForKey("backend_validation")}
          checked={editFieldData.validate.backend_validation}
          name="backend_validation"
          size="medium"
          containerClassName="w_50"
          onChange={({ target }) => handleChangeValidationInput(target.name, target.checked)}
        />
        <Input
          type="checkbox"
          label={getLabelForKey("prefill_filtered_data")}
          checked={editFieldData.prefill_filtered_data}
          name="prefill_filtered_data"
          onChange={({ target }) => handleChangeInput(target.name, target.checked)}
          containerClassName="w_50"
        />
      </div>
      <SelectSubfields
        label={getLabelForKey("access_fields")}
        name="access_fields"
        value={editFieldData.access_fields}
        onChange={(newFields) => handleChangeInput("access_fields", newFields)}
        tableId="appuser"
        tableType="appuser"
      />
      <AppUserFilter
        value={editFieldData.app_user_filter}
        onChange={(data) => handleChangeInput("app_user_filter", data)}
      />
      <div className="field_horizontal_container">
        <Input
          label={getLabelForKey("help_text")}
          value={editFieldData.help_text}
          name="help_text"
          onChange={({ target }) => handleChangeInput(target.name, target.value)}
        />
      </div>
    </>
  );
};

export default EditAppuser;
